import { DirectedTripleWithFilters } from '@ardoq/api-types';

const getStartTypeFromPaths = (paths: DirectedTripleWithFilters[][]) => {
  const firstTriple = paths[0]?.[0];
  if (!firstTriple) return null;
  const { sourceType, targetType, direction } = firstTriple;
  return direction === 'outgoing' ? sourceType : targetType;
};

export const pathOperations = {
  getStartTypeFromPaths,
};
